import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-arrow-left\">\n    <path d=\"M8.10938 6.96094L9.16406 8.03906L5.95312 11.25L21 11.25V12.75L5.95313 12.75L9.16406 15.9609L8.10938 17.0391L3.07031 12L8.10938 6.96094Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol